import Navbar from '../features/Navbar/Navbar'
import AdminOrders from '../features/admin/component/AdminOrders';


function AdminOrdersPage() {
  return (
    <div>
        <Navbar/>
            <AdminOrders/>
       
    </div>
  );
}
export default AdminOrdersPage;
